import { useCallback, useEffect, useRef, useState, useTransition } from 'react';

import { fetchListLimits } from '~modules/limits/api';
import { LimitDto } from '~modules/limits/dto';

export function useLimits(sectionId?: number) {
	const [list, setList] = useState<LimitDto[]>([]);
	const [pending, startLoading] = useTransition();
	const isFirstRender = useRef(true);

	const refresh = useCallback(() => {
		if (!sectionId) setList([]);
		else {
			startLoading(async () => {
				const data = await fetchListLimits(sectionId);
				setList(data);
			});
		}
	}, [sectionId]);

	useEffect(() => {
		isFirstRender.current = false;
		refresh();
	}, [refresh]);

	return { pending, list };
}
